export class ProductividadEstado {
    constructor( Estado, Conteo) {
        this.Estado= Estado;
        this.Conteo=Conteo;
    }
}